const darkmode_css = `.page {
        color: rgb(190, 184, 176);
        background-color: #181a1b;
    }

    #loader {
        background-color: rgba(24, 26, 27, 0.95)!important;
    }

    .loading #loader div {
        background-color: rgb(24, 26, 27)!important;
        box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 3px!important;
    }

    #bar {
        background-image: initial;
        background-color: rgb(50, 62, 69);
        border-left-color: rgb(48, 52, 54);
        border-right-color: rgb(48, 52, 54);
    }

    #user h1 {
        color: rgb(183, 176, 167);
    }

    #user p {
        color: rgb(169, 161, 150);
    }

    #user path {
        fill: #c8c3bc!important;
    }

    #user .social::after {
        background-image: initial;
        background-color: rgb(32, 35, 36);
    }

    #footer {
        color: rgb(164, 156, 144);
    }

    #footer a {
        color: rgb(190, 184, 176);
    }

    #posts > .post:hover {
        background-image: initial;
        background-color: rgb(29, 31, 32);
    }

    #posts > .post span {
        color: rgb(173, 166, 155);
        background-image: initial;
        background-color: rgb(37, 40, 42);
        border-color: rgb(56, 61, 64);
    }

    #post > h1 {
        color: rgb(190, 184, 176);
    }

    #posts p {
        color: rgb(154, 146, 132);
    }

    #post > p {
        color: rgb(154, 146, 132);
    }

    #post > p span {
        color: rgb(172, 165, 154);
    }

    #posts h2 {
        color: rgb(178, 171, 161);
    }

    #post .labels a {
        color: rgb(168, 160, 149);
        text-decoration-color: initial;
    }

    .filter {
        color: rgb(178, 171, 161);
    }

    .filter .splite svg path {
        fill: rgb(178, 171, 161);
    }

    .markdown-body {
        color: rgb(200, 195, 188);
    }

    .markdown-body h1,
    .markdown-body h2 {
        border-bottom-color: rgb(53, 58, 60);
    }

    .markdown-body h1, .markdown-body h2, .markdown-body h3, .markdown-body h4, .markdown-body h5, .markdown-body h6 {
        color: rgb(232, 230, 227);
    }

    .markdown-body blockquote {
        color: rgb(159, 151, 138);
        border-left-color: rgb(56, 61, 63);
    }

    .markdown-body a {
        color: rgb(45, 141, 248);
        text-decoration-color: initial;
    }

    .markdown-body hr {
        border-bottom-color: rgb(53, 57, 59);
    }

    .markdown-body .img-center img {
        background-image: initial;
        background-color: rgb(24, 26, 27);
        border-color: rgb(67, 73, 76);
        box-shadow: rgb(48, 52, 54) 1px 1px 3px;
    }

    .markdown-body .img-broken img {
        box-shadow: none;
        border-color: initial;
    }

    .button {
        color: rgb(166, 159, 147);
        background-image: initial;
        background-color: rgb(24, 26, 27);
        border-color: rgb(64, 70, 72);
    }

    .comment-list .comment-body > a {
        color: rgb(200, 195, 188);
        text-decoration-color: initial;
    }

    .comment-list .comment-body span {
        color: rgb(157, 149, 136);
    }

    #memos .timelines,
    #inbox .timelines {
        border-left-color: rgb(56, 61, 63);
    }

    #memos .timeline-icon {
        box-shadow: rgb(24, 26, 27) 0px 0px 0px 6px;
    }

    #memos .timeline-description,
    #inbox .timeline-description {
        color: rgb(154, 146, 132);
    }

    #memos .comment,
    #inbox .comment {
        color: rgb(193, 188, 180);
        box-shadow: 0 4px 4px 0 var(--darkreader-bg--c-grey-100);
        border-color: rgb(56, 61, 63);
    }

    #memos .comment a,
    #inbox .comment a {
        color: #3391ff;
    }

    #memos blockquote,
    #inbox blockquote {
        color: rgb(163, 155, 143);
        border-left-color: rgb(59, 64, 67);
    }

    .toolbar svg path {
        fill: #beb9b0 !important;
    }

    #preview {
        background-color: rgb(24, 26, 27);
    }

    #preview .close path {
        fill: #ffffff !important;
    }

    #plugin-sr-uploading diglog,
    #plugin-sr-uploading dialog-content,
    #plugin-sr-uploading dialog-footer {
        color: rgba(232, 230, 227, 0.87)!important;
        background-color: #181a1b!important;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 45px, rgba(0, 0, 0, 0.22) 0px 10px 18px!important;
    }

    #plugin-sr-uploading .status {
        color: rgba(232, 230, 227, 0.87) !important;
    }

    #plugin-sr-addpost dialog-content, #plugin-sr-addpost dialog-footer {
        color: #b8bfc6!important;
        background-color: #2e2e2e!important;
    }

    #plugin-sr-login diglog,
    #plugin-sr-login dialog-content,
    #plugin-sr-login dialog-footer {
        color: rgba(232, 230, 227, 0.87)!important;
        background-color: #181a1b!important;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 45px, rgba(0, 0, 0, 0.22) 0px 10px 18px!important;
    }

    #plugin-sr-login .split .text {
        color: rgb(186, 180, 171);
    }

    #plugin-sr-login .split .line {
        border-top-color: rgb(57, 61, 64);
    }

    #plugin-sr-login text-field-border {
        border-top-color: #393d40 !important;
        border-right-color: #393d40 !important;
        border-left-color: #393d40 !important;
        border-bottom-color: #393d40 !important;
    }
`;

function render( callback ) {
    let tmpl = `<div class="darkmode">
                    <input type="checkbox" class="checkbox" id="checkbox">
                    <label for="checkbox" class="checkbox-label">
                        <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path d="M713.28 734.08A328 328 0 0 1 288 308.8a32 32 0 0 0-44.48-40.32 378.88 378.88 0 1 0 510.08 510.08 32 32 0 0 0-40.32-44.48zM427.2 199.04l42.88 14.4a90.56 90.56 0 0 1 57.28 57.28l14.4 42.88a17.28 17.28 0 0 0 32 0l14.4-42.88a90.56 90.56 0 0 1 57.28-57.28l42.88-14.4a17.28 17.28 0 0 0 0-32l-42.88-14.4A90.56 90.56 0 0 1 588.8 96L576 51.84a17.28 17.28 0 0 0-32 0L527.36 96a90.56 90.56 0 0 1-57.28 57.28l-42.88 14.4a17.28 17.28 0 0 0 0 32z m559.04 239.36l-42.88-14.4a90.56 90.56 0 0 1-57.28-57.28l-14.4-42.88a17.28 17.28 0 0 0-32 0l-14.4 42.88a90.56 90.56 0 0 1-57.28 57.6l-42.88 14.4a17.28 17.28 0 0 0 0 32l42.88 14.4A90.56 90.56 0 0 1 824.64 544l14.4 42.88a17.28 17.28 0 0 0 32 0l15.04-42.88a90.56 90.56 0 0 1 57.28-57.28l42.88-14.4a17.28 17.28 0 0 0 0-32z" fill="#f1c40f"></path></svg>
                        <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path d="M900.8 432.96a137.92 137.92 0 0 1-58.24-140.16c14.72-76.16 27.52-101.12 8.64-120.32s-43.84-6.08-120.32 8.64a137.92 137.92 0 0 1-140.16-58.24C547.52 58.88 538.88 32 512 32s-35.52 26.88-79.04 91.2a137.92 137.92 0 0 1-140.16 57.92C216.64 166.4 192 153.6 172.48 172.48s-6.08 43.84 8.64 120.32a137.92 137.92 0 0 1-58.24 140.16C58.88 476.48 32 485.12 32 512s26.88 35.52 91.2 79.04a137.92 137.92 0 0 1 57.92 140.16c-14.72 76.16-27.52 100.8-8.64 120.32s43.84 6.08 120.32-8.64a137.92 137.92 0 0 1 140.16 58.24c43.52 64 52.16 90.88 79.04 90.88s35.52-26.88 79.04-90.88a137.92 137.92 0 0 1 140.16-58.24c76.16 14.72 101.12 27.52 120.32 8.64s6.08-43.84-8.64-120.32a137.92 137.92 0 0 1 57.92-140.16C965.12 547.52 992 538.88 992 512s-26.88-35.52-91.2-79.04zM512 752a240 240 0 1 1 240-240 240 240 0 0 1-240 240zM512 352a160 160 0 1 0 160 160 160 160 0 0 0-160-160z" fill="#f39c12"></path></svg>
                        <span class="ball"></span>
                    </label>
                </div>`;
    $( 'body' ).append( tmpl );
    $( '.darkmode #checkbox' ).on( 'change', event => {
        localStorage.setItem( 'darkmode', event.currentTarget.checked );
        if ( event.currentTarget.checked ) {
            $( 'head' ).append( `<style class="darkmode_theme" type="text/css">${ darkmode_css }</style>` );
        } else {
            $( 'head' ).find( '.darkmode_theme' ).remove();
        }
        callback && callback( event.currentTarget.checked ? 'dark' : 'light' );
    })
    if ( localStorage.getItem( 'darkmode' ) == 'true' ) {
        $( '.darkmode #checkbox' ).click();
    }
}

module.exports = {
    render
};